'use client';

import React from 'react';

import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';

import { LinkBuyCrypto } from '@/blocks/components/PlatformLink';
import { EventBlockNames } from '@/providers/analytics/types';
import buttons from '@/styles/button.module.scss';
import context from '@/styles/contexts.module.scss';

import { DEFAULT_SELECTED_TOKEN } from '@/app/[lang]/buy-crypto/components/ConverterWidget/useConverter';

import { ConverterHeader, ConverterWidget } from '../../components/ConverterWidget';
import styles from './styles.module.scss';

export const BuyCryptoBlock = () => {
  const coin = useParams().coin as string;
  const tr = useTranslations();

  return (
    <div className={styles.bcBlock} data-event-block-name={EventBlockNames.buy_crypto_widget}>
      <div className={classNames(styles.widget, context.light)}>
        <ConverterHeader selectedToken={coin?.toUpperCase() ?? DEFAULT_SELECTED_TOKEN} />
        <ConverterWidget
          shouldNavigate={true}
          initialSelectedToken={coin}
          renderCta={({ selectedToken, selectedFiat, payAmount }) => (
            <LinkBuyCrypto
              from={selectedFiat}
              to={selectedToken}
              amountFrom={payAmount}
              className={classNames(buttons.btn, buttons.btnM, buttons.btnPrimary, styles.actionButton)}
              data-event-label={tr.rich('en.pages.buyCrypto.converterWidget.mainCta')}
            >
              {tr('pages.buyCrypto.converterWidget.mainCta')}
            </LinkBuyCrypto>
          )}
        />
      </div>
    </div>
  );
};
